// client/src/App.js
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PendingBadgeProvider } from './context/PendingBadgeContext';
import Discover from './pages/Discover';
import DiscoverHistory from './pages/DiscoverHistory';
import DiscoverViewedDetail from './pages/DiscoverViewedDetail';
import Messages from './pages/Messages';
import Profile from './pages/Profile';
import ProfileDetail from './pages/ProfileDetail';
import ProfileEdit from './pages/ProfileEdit';
import Match from './pages/Match';
import MatchSuccess from './pages/MatchSuccess';
import ActivityDetail from './pages/ActivityDetail';
import Activities from './pages/Activities';
import MyRegistrations from './pages/MyRegistrations';
import Membership from './pages/Membership';
import Buy from './pages/Buy';
import Settings from './pages/Settings';
import AdminLogin from './pages/admin/AdminLogin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminGuard from './pages/admin/AdminGuard';
import AdminActivities from './pages/admin/AdminActivities';
import AdminActivityForm from './pages/admin/AdminActivityForm';
import AdminRegistrations from './pages/admin/AdminRegistrations';
import AdminMembershipSettings from './pages/admin/AdminMembershipSettings';
import AdminMembers from './pages/admin/AdminMembers';
import AdminMemberForm from './pages/admin/AdminMemberForm';

function App() {
  return (
    <BrowserRouter>
      <PendingBadgeProvider>
      <Routes>
        {/* 带底部导航的页面 */}
        <Route path="/" element={<Navigate to="/discover" replace />} />
        <Route path="/discover" element={<Discover />} />
        <Route path="/discover/history" element={<DiscoverHistory />} />
        <Route path="/discover/viewed/:id" element={<DiscoverViewedDetail />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/profile" element={<Profile />} />
        
        {/* 不带底部导航的页面 */}
        <Route path="/profile/edit" element={<ProfileEdit />} />
        <Route path="/profile/:id" element={<ProfileDetail />} />
        <Route path="/match/:id" element={<Match />} />
        <Route path="/match/success/:id" element={<MatchSuccess />} />
        <Route path="/activity/:id" element={<ActivityDetail />} />
        <Route path="/match-history" element={<Messages defaultTab="history" />} />
        <Route path="/my-registrations" element={<MyRegistrations />} />
        <Route path="/membership" element={<Membership />} />
        <Route path="/buy" element={<Buy />} />
        <Route path="/settings" element={<Settings />} />

        {/* 管理后台 - 无入口链接，需直接访问 /admin */}
        <Route path="/admin">
          <Route index element={<AdminLogin />} />
          <Route element={<AdminGuard />}>
            <Route element={<AdminLayout />}>
              <Route path="activities" element={<AdminActivities />} />
              <Route path="activities/new" element={<AdminActivityForm />} />
              <Route path="activities/:id/edit" element={<AdminActivityForm />} />
              <Route path="registrations" element={<AdminRegistrations />} />
              <Route path="members" element={<AdminMembers />} />
              <Route path="members/new" element={<AdminMemberForm />} />
              <Route path="members/:id/edit" element={<AdminMemberForm />} />
              <Route path="membership" element={<AdminMembershipSettings />} />
            </Route>
          </Route>
        </Route>
      </Routes>
      </PendingBadgeProvider>
    </BrowserRouter>
  );
}

export default App;
